import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../lang-change';
import {Principal} from '../../../../common/services/principal';
import {Language} from '../../../../common/models/language';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {Utils} from '../../../../common/services/Utils';
import {TechSupportService} from '../../../shared/services/tech-support.service';
import {TechSupportFaqModalComponent} from './faq-modal/tech-support-faq-modal.component';
import {PageDTO} from '../../../../common/dtos/PageDTO';
import {ConfirmDialogComponent} from '../../../../common/dialogs/confirm-dialag/confirm-dialag.component';
import {animate, style, transition, trigger} from '@angular/animations';
import {TechFaq} from './tech-faq';
import {TechSupportForm} from './tech-support-form';

@Component({
  selector: 'app-tech-support',
  templateUrl: './tech-support.component.html',
  styleUrls: ['./tech-support.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({opacity: 0}),
        animate(500, style({opacity: 1}))
      ]),
      transition(':leave', [
        animate(500, style({opacity: 0}))
      ])
    ])
  ]
})
export class TechSupportComponent extends LangChange implements OnInit {

  page: PageDTO = new PageDTO();
  langId: number;
  techData: any;
  isModerator = false;
  faqs: TechFaq[];
  totalElements = 0;
  dtoList: any = [];
  visibleItems: number[] = [];
  techForm: TechSupportForm = new TechSupportForm();

  constructor(private translateService: TranslateService,
              private techService: TechSupportService,
              private router: Router,
              private dialog: MatDialog,
              private principal: Principal,
              private utils: Utils) {
    super(translateService);
    this.langId = Language.getCurrentLanguage().id;
  }

  ngOnInit() {
    this.page.size = 10;
    this.page.filter = {};
    this.getAdminData();
    this.loadData(true);
  }

  getAdminData() {
    this.techService.getAdminData().subscribe(
      res => {
        this.techData = res;
        if (this.principal.isLoggedIn()) {
          this.techData.moderators.forEach(x => {
            if (!this.isModerator) {
              this.isModerator = (x['id'] === this.principal.getUserId());
            }
          });
        }
        this.onChangeLang();
      }
    );
  }

  expandRow(id: number) {
    const ind = this.visibleItems.indexOf(id);
    if (ind !== -1) {
      this.visibleItems.splice(ind, 1);
    } else {
      this.visibleItems.push(id);
    }
  }

  checkExpand(id: number): boolean {
    return this.visibleItems.indexOf(id) !== -1;
  }

  sendMessage() {
    this.utils.blockStart(null);
    this.techService.sendMessage(this.techForm).subscribe(
      (res) => {
        if (res.status === 'SUCCESS') {
          this.utils.notifySuccess(this.translateService.instant('tech_support.message_sent_success'), null);
        } else {
          this.utils.notifyError(this.translateService.instant('error_occurred'), null);
        }
        this.utils.blockStop();
      },
      error => {
        this.utils.notifyError(this.translateService.instant('error_occurred'), null);
        this.utils.blockStop();
      }
    );
  }

  loadData(resetPage) {
    if (resetPage) {
      this.page.pageNumber = 0;
    }
    this.techService.getModeratorFAQ(this.page).subscribe(data => {
      this.faqs = data.dtoList;
      this.totalElements = data.totalElements;
      this.onChangeLang();
    });
  }

  addFAQ(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(TechSupportFaqModalComponent, {
      width: '900px',
      height: '450px',
      data: {
        // type: type
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadData(true);
      }
    });
  }

  onEdit(id: number): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(TechSupportFaqModalComponent, {
      width: '900px',
      height: '450px',
      data: {
        faqId: id
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadData(true);
      }
    });
  }

  iLikeIt(item: TechFaq) {
    this.techService.iLikeIt(item.id).subscribe(
      res => {
        item.likesCount = res;
      }
    );
  }

  openDeleteWindow(id: number): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {message: 'confirm_delete'}
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.utils.blockStart(null);
          this.techService.deleteFAQ(id).subscribe((data) => {
            this.utils.checkMessage(data, succ => {
                this.utils.notifySuccess(this.translateService.instant('deleted'), null);
              },
              err => {
              });
            this.utils.blockStop();
            this.loadData(true);
          });
        }
      }
    );
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
    this.onChangeLang();
  }

  onChangeLang() {
    if (this.techData) {
      Language.updateLocalizedName(this.techData);
    }
    if (this.faqs) {
      for (let i = 0; i < this.faqs.length; i++) {
        if (this.langId === 2) {
          this.faqs[i].question = this.faqs[i].questionRu;
          this.faqs[i].answer = this.faqs[i].answerRu;
        } else if (this.langId === 3) {
          this.faqs[i].question = this.faqs[i].questionEn;
          this.faqs[i].answer = this.faqs[i].answerEn;
        } else if (this.langId === 1) {
          this.faqs[i].question = this.faqs[i].questionKz;
          this.faqs[i].answer = this.faqs[i].answerKz;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/tech-support/tech-support.component.ts